import { css } from "@emotion/css";
import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { getIsWhiteLabeled } from "../../../helpers/PermissionHelper";

interface IBPLoanDetailEditButtonsProps {
  brokerColor: any;
  isEditMode: any;
  setIsEditMode: any;
  editDetailsHandler: any;
  saveChangesHandler: any;
  discardChangesHandler: any;
}

const BPLoanDetailEditButtons = ({...props}: IBPLoanDetailEditButtonsProps) => {
  const brokerButtonOverrideCSS = css`
    background-color: ${props.brokerColor ? props.brokerColor : "black"} !important;
    color:#ffffff !important;
    font-family: $fontFamily !important;
    margin-top: 10px;
    width: 25%;
  `;

  return (
    <React.Fragment>
      <Button
        className={getIsWhiteLabeled() ? `details-button ${brokerButtonOverrideCSS}` : "bp-button details-button"}
        icon
        basic
        onClick={() => props.editDetailsHandler(props.setIsEditMode)}
        disabled={props.isEditMode}
        >
        <div className="gmr-button-container">
          <Icon name='edit outline' size="large" />
          <div className="gmr-button-icon-text">Edit Details</div>
        </div>
      </Button>
      <Button
        className={getIsWhiteLabeled() ? `details-button ${brokerButtonOverrideCSS}` : "bp-button details-button"}
        icon
        basic
        floated='right'
        onClick={() => props.saveChangesHandler()}
        disabled={!props.isEditMode}
        >
        <div className="gmr-button-container">
          <Icon name='save outline' size="large" />
          <div className="gmr-button-icon-text">Save Changes</div>
        </div>
      </Button>
      <Button
        className={getIsWhiteLabeled() ? `details-button ${brokerButtonOverrideCSS}` : "bp-button details-button"}
        icon
        basic
        floated='right'
        onClick={() => props.discardChangesHandler()}
        disabled={!props.isEditMode}
        >
        <div className="gmr-button-container">
          <Icon name='trash alternate outline' size="large" />
          <div className="gmr-button-icon-text">Discard Changes</div>
        </div>
      </Button>
    </React.Fragment>
  );
};

export default BPLoanDetailEditButtons;